@if (groupOrderModel.hasGroupOrder() || orderModel.totalTransfers() || showWithoutGroupOrder()) {
    <div class="group-order-summary" [class.highlighted]="highlighted()">
        <woa-icon class="group-order-summary-icon" [name]="'users'"></woa-icon>
        @if (groupOrderModel.hasGroupOrder() || orderModel.totalTransfers()) {
            <div class="group-order-summary-count"
                 [ngClass]="'theme-' + countColorPair() + '-color-pair'">{{ orderModel.totalTransfers() }}
            </div>
        }
    </div>
}
